const snapshotWithKey = snapshot => {
  if (snapshot.val()) {
    return {
      id: snapshot.key,
      ...snapshot.val(),
    };
  }
  return {};
};

// A read the database rules refused. The SDK reports these as `PERMISSION_DENIED` codes or "Permission denied" messages.
const isPermissionDenied = error => /permission[ _]denied/i.test(`${error?.code || ''} ${error?.message || ''}`);

export {snapshotWithKey, isPermissionDenied};
export default snapshotWithKey;
